import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

export default function Logout({ show, close, initialFocus }) {
  const LogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("firstTime", "true");
    window.location.pathname = "/";
  };

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 modalUp inset-0 overflow-y-auto"
        initialFocus={initialFocus}
        onClose={close}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative  inline-block align-bottom bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full">
              <div className="bg-white px-4 ">
                <div className="mt-3 text-center sm:mt-0 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="text-[24px] BoldFonter mt-5 mb-10 text-center leading-6 font-medium text-hervestPink"
                  >
                    Log out
                  </Dialog.Title>
                  <div className="mt-2 ">
                    <p className="text-sm text-center text-gray-500 ml-2">
                      Are you sure you want to log out? By clicking <b>"YES"</b>{" "}
                      you will be logged out.
                    </p>
                  </div>
                </div>

                <hr className="mt-10" />
                <div className="flex flex-row justify-center space-x-5 mb-5">
                  <button
                    onClick={() => LogOut()}
                    className="w-1/3 border border-[#5B2E4F]  mt-10 text-[#5B2E4F] BoldFonter rounded-md h-10 text-center text-[14px] font-[500px] leading-4"
                  >
                    YES
                  </button>
                  <button
                    onClick={() => close(false)}
                    className="w-1/3 border border-[#5B2E4F] mt-10 BoldFonter text-white bg-[#5B2E4F] rounded-md h-10 text-center text-[14px] font-[500px] leading-4"
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
